<div class="user-data-validation">
    <form>
        <div class="form-content-wrapper">
            <input-component class="name-input" label="geral.user-validation.general-data.form.label.first-name" [control]="firstNameControl" />
            <input-component class="name-input" label="geral.user-validation.general-data.form.label.last-name" [control]="lastNameControl" />
            <input-component class="name-input" label="geral.user-validation.general-data.form.label.phone" [mask]="phoneMask" [control]="phoneControl" />
        </div>
        <div class="buttons">
            <button customButton type="submit" [styleType]="'secondary'" [isLoading]="false" label="geral.user-validation.general-data.form.submit" (click)="nextStep()"></button>
        </div>
    </form>
</div>
